import React, {Component} from 'react';

import {applyMiddleware, compose, createStore} from 'redux';
import {Provider} from 'react-redux'
import PageLayout from './ui/pageLayout/PageLayout';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import thunk from 'redux-thunk';
import {browserHistory, IndexRoute, Redirect, Route, Router} from 'react-router';
import ReactGA from 'react-ga';
// Pages
import ConnexionLayout from './ui/connexion/ConnexionLayout';
import Login from './ui/connexion/login/Login';
import HomePage from './ui/home/HomePage';
import UserDashboardPage from './ui/userDashboard/UserDashboardPage';
import AddUserPage from './ui/addUser/AddUserPage';
import EditUserPage from './ui/editUser/EditUserPage';
import FirstConnexion from './ui/connexion/firstConnexion/FirstConnexion';
import ResetPassword from './ui/connexion/resetPassword/ResetPassword';
import EditMyAccount from './ui/editMyAccount/EditMyAccount';
import EditMyPassword from './ui/editMyPassword/EditMyPassword';
import JobHistoryPage from './ui/jobHistory/JobHistoryPage';
import Version from './ui/version/Version.js';
import ReportingPeriodicPage from './ui/reportingPeriodic/ReportingPeriodic.js';
import TransactionPage from './ui/transaction/Transaction';
import ShopPage from "./ui/shop/ShopPage";
import InvoicePage from "./ui/invoice/InvoicePage";

import marketPayReduceur from './store/reduceurs';
import T from 'i18n-react';
//Utils
import {getCookie, setCookie} from './utils/CookieUtils';
// Enums
import PAGES from './enums/PageEnum';
import {getMuiTheme} from 'material-ui/styles';


const customTheme = {
    fontFamily: 'Roboto, sans-serif',
    palette: {
        //Couleur des boutons par défaut
        alternateTextColor: '#AAAAAA',
        //Couleur des boutons primary
        primary1Color: '#373F51',
        //Couleur des boutons secondary
        accent1Color: '#0A9A8F',
    },
    raisedButton: {
        textTransform: 'none',
        //Couleur du texte des raisedButton par défaut
        textColor: '#000000',
        //Couleur du texte des raisedButton primary
        primaryTextColor: '#DDDDDD',
        //Couleur du texte des raisedButton secondary
        secondaryTextColor: '#DDDDDD',
    },
    datePicker: {
        textColor: '#FFFFFF',
        selectTextColor: '#FFFFFF',
    },
    timePicker: {
        textColor: '#FFFFFF',
        selectTextColor: '#FFFFFF',
    },
};

let composeEnhancers = compose;
// Ajout de l'outil de debug redux si nous sommes en environnement de dev
if (process.env.NODE_ENV === 'development') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

// Init le store 
export const store = createStore(
    marketPayReduceur,
    composeEnhancers(applyMiddleware(thunk))
);

class App extends Component {

    constructor(props) {
        super(props);
        //Initialisation Google Analytics
        if (window.location.host === 'marketpay.steamulo.org') {
            ReactGA.initialize('UA-111831702-2');
        } else {
            ReactGA.initialize('UA-111831702-1');
        }
    };

    // Set language 
    setLanguageCookie() {
        // Récupération du cookie de langue 
        let language = getCookie('marketPayLanguage');
        // Si on a pas le cookie de langue on va chercher la langue du navigateur
        if (!language) {
            language = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
            // language would be something like es-ES or es_ES
            // However we store our files with format es.json or en.json
            // therefore retrieve only the first 2 digits
            if (language.length > 2) {
                language = language.split("-")[0];
                language = language.split("_")[0];
            }
        }
        setCookie({name: 'marketPayLanguage', value: language});
        T.setTexts(require('./resources/i18n/' + language + '.json'));
    }

    componentWillMount() {
        this.setLanguageCookie();
        injectTapEventPlugin();
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={getMuiTheme(customTheme)}>
                <Provider store={store}>
                    <Router onUpdate={this.fireTracking} history={browserHistory}>
                        <Route path="/login" component={ConnexionLayout}>
                            <IndexRoute component={Login}/>
                            <Route path={PAGES.FIRST_CONNEXION_PAGE} component={FirstConnexion}/>
                            <Route path={PAGES.RESET_PASSWORD} component={ResetPassword}/>
                        </Route>
                        <Route path="/version" component={Version}/>
                        <Route path="/" components={PageLayout}>
                            <IndexRoute component={HomePage}/>
                            <Route path={PAGES.USER_ADD} component={AddUserPage}/>
                            <Route path={PAGES.USER_MANAGER} component={UserDashboardPage}/>
                            <Route path={PAGES.USER_EDIT} component={EditUserPage}/>
                            <Route path={PAGES.EDIT_MY_ACCOUNT} component={EditMyAccount}/>
                            <Route path={PAGES.EDIT_MY_PASSWORD} component={EditMyPassword}/>
                            <Route path={PAGES.JOB_HISTORY} component={JobHistoryPage}/>
                            <Route path={PAGES.REPORTING_PERIODIC_PAGE} component={ReportingPeriodicPage}/>
                            <Route path={PAGES.TRANSACTION_PAGE} component={(props) => (<TransactionPage {...props} type='ACC' />)}/>
                            <Route path={PAGES.FINANCED_TRANSACTION_PAGE} component={(props) => (<TransactionPage {...props} type='ACQ' />)}/>
                            <Route path={PAGES.SHOP_PAGE} component={ShopPage}/>
                            <Route path={PAGES.INVOICE_PAGE} component={InvoicePage}/>
                        </Route>
                        <Redirect from='*' to='/login'/>
                    </Router>
                </Provider>
            </MuiThemeProvider>
        );
    }

    fireTracking() {
        ReactGA.pageview(window.location.pathname)
    }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js